import { Component, TemplateRef, inject } from '@angular/core';
import { ToastService } from './toast.service';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

interface ToastEnum {
  autohide: boolean;
  classname: string;
  delay: number;
  textOrTpl: string;
}

@Component({
  selector: 'app-toasts',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  imports: [NgbToastModule],
  host: { '[class.ngb-toasts]': 'true' },
})
export class ToastComponent {
  toastService = inject(ToastService);

  private toast: ToastEnum;

  isTemplate(toast) {
    this.toast = toast;
    return toast.textOrTpl instanceof TemplateRef;
  }

  removeToast() {
    if (
      this.toast &&
      this.toast.textOrTpl === 'Please do not leave empty seats'
    ) {
      this.toastService.onNotificationClose$.next(true);
    }
  }
}
